import React from 'react';
import ModelEntity from "../../../../../../model2/model-entity";
import FieldProto from "../../../../../proto/field-proto";

type Props = {
    field               : FieldProto,
    value?              : any,
    model               : ModelEntity           // some dropdowns need model to build options i.e. taskAssignee is based on projectId

    configOptions?      : any
    disabled?           : boolean,

    onChange?           : onChangeCallback,

    className?          : string
}

type State = {
    showPopover         : boolean
}

export default class DropdownFormStatelessView extends React.Component<Props,State> {

    constructor(props:Props) {
        super(props);

        this.state = {
            showPopover         : false,
        }
    }

    showPopover = (e?:React.SyntheticEvent) => {
        e?.stopPropagation()

        if (!this.state.showPopover && !this.props.disabled) this.setState({showPopover: true})
    }
    hidePopover = () => {if (this.state.showPopover) this.setState({showPopover: false})}

    onOptionClick = (option:any) => {
        if (!option || (_.isNil(option.value) && !this.props.field.hasOptionWithNullValue)) option = null;

        if (this.props.onChange) this.props.onChange(_.get(option, 'value', null));
        this.hidePopover()
    }

    render() {
        const {field}   = this.props;

        const classes   = Classes(this.props.className, {
            'show-popover'  : this.state.showPopover,
            'is-disabled'   : this.props.disabled
        });

        const currentOption       = this.props.field._getOption(this.props.value, this.props.model)

        // need check value because of none
        if (currentOption && (field.hasOptionWithNullValue || !_.isNil(currentOption.value))) {
            return (
                <field.components.FormValueNotEmpty className       = {classes}
                                                    field           = {field}
                                                    option          = {currentOption}
                                                    configOptions   = {this.props.configOptions}
                                                    disabled        = {this.props.disabled}
                                                    onClick         = {this.showPopover}
                                                    onOptionClick   = {this.onOptionClick}>
                    {this.state.showPopover &&
                        <field.components.PopoverMenu {...this.props}
                                                      currentOption = {currentOption}
                                                      parent        = {this} />
                    }

                </field.components.FormValueNotEmpty>
            );
        }

        // No value
        return (
            <field.components.FormValueEmpty className      = {classes}
                                             field          = {field}
                                             configOptions  = {this.props.configOptions}
                                             disabled       = {this.props.disabled}
                                             onClick        = {this.showPopover}>
                {this.state.showPopover && <field.components.PopoverMenu {...this.props} parent={this} />}
            </field.components.FormValueEmpty>
        );
    }
}
